// extracted by mini-css-extract-plugin
export default {"container":"modal-content-layout-module__container___8f37bd"};